// extracted by css-extract-rspack-plugin
export default {"CheckIcon":"PlansRadioGroup-module__CheckIcon__I6QZFrI"};